import { MapTo } from "@adobe/aem-react-editable-components";
import { BlogListing } from "@jti/ui";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const articlesListEditConfig = {
    emptyLabel: "Articles List",
    isEmpty: (props) => !props.title || !props.path,
    getProps: (props) => ({
        articles: props.articles,
        title: props.title,
        isInEditor: props.isInEditor,
        disableTiers: props.disableTiers,
        errorMessage: props.errorMessage,
        path: props.path,
        disableLoyalty: false,
        isInAemSpa: true,
    }),
};
export default MapTo("loyalty/components/articleslist")(withAemAuthoring(BlogListing, articlesListEditConfig));
